"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BasicToast = _interopRequireDefault(require("../BasicToast"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/prop-types: "off" */
function createToastMiddleware() {
  return function () {
    return function () {
      return function (_ref) {
        var notification = _ref.notification;
        return /*#__PURE__*/_react.default.createElement(_BasicToast.default, {
          notification: notification
        });
      };
    };
  };
}

var _default = createToastMiddleware;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVUb2FzdE1pZGRsZXdhcmUiLCJub3RpZmljYXRpb24iXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ub2FzdC9jcmVhdGVUb2FzdE1pZGRsZXdhcmUudHN4Il0sInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludCByZWFjdC9wcm9wLXR5cGVzOiBcIm9mZlwiICovXG5cbmltcG9ydCB7IFRvYXN0TWlkZGxld2FyZSB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgQmFzaWNUb2FzdCBmcm9tICcuLi9CYXNpY1RvYXN0JztcblxuZnVuY3Rpb24gY3JlYXRlVG9hc3RNaWRkbGV3YXJlKCk6IFRvYXN0TWlkZGxld2FyZSB7XG4gIHJldHVybiAoKSA9PlxuICAgICgpID0+XG4gICAgKHsgbm90aWZpY2F0aW9uIH0pID0+XG4gICAgICA8QmFzaWNUb2FzdCBub3RpZmljYXRpb249e25vdGlmaWNhdGlvbn0gLz47XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNyZWF0ZVRvYXN0TWlkZGxld2FyZTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUVBOzs7O0FBTEE7QUFPQSxTQUFTQSxxQkFBVCxHQUFrRDtFQUNoRCxPQUFPO0lBQUEsT0FDTDtNQUFBLE9BQ0E7UUFBQSxJQUFHQyxZQUFILFFBQUdBLFlBQUg7UUFBQSxvQkFDRSw2QkFBQyxtQkFBRDtVQUFZLFlBQVksRUFBRUE7UUFBMUIsRUFERjtNQUFBLENBREE7SUFBQSxDQURLO0VBQUEsQ0FBUDtBQUlEOztlQUVjRCxxQiJ9